import { render } from "./EditCompetitor.vue?vue&type=template&id=396aba30"
import script from "./EditCompetitor.vue?vue&type=script&lang=js"
export * from "./EditCompetitor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__